module.exports = __webpack_public_path__ + "static/media/m-penguincube.c61cec15.png";